import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles.css';
import { enregistrerServiceWorker } from './registerSW.ts';
import { demarrerSynchroModules } from './offline/dbModules.ts';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

enregistrerServiceWorker();
demarrerSynchroModules(); // file d'attente des modules : active dès l'ouverture de l'app, pas seulement sur l'écran de saisie
